import { render, staticRenderFns } from "./CampaignUserDetail.vue?vue&type=template&id=0c6555df&scoped=true"
import script from "./CampaignUserDetail.vue?vue&type=script&lang=js"
export * from "./CampaignUserDetail.vue?vue&type=script&lang=js"
import style0 from "./CampaignUserDetail.vue?vue&type=style&index=0&id=0c6555df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6555df",
  null
  
)

export default component.exports